import React from 'react';
import FlowLine from '../ui/FlowLine';
import ScrollReveal from '../ui/ScrollReveal';
import { Heart, Users, Zap, Clock, Award } from 'lucide-react';
const SuccessSection = () => {
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#EDE8F5] relative overflow-hidden" id="features" data-id="element-458">
      <FlowLine className="top-1/4 left-0 w-full h-24" data-id="element-459" />
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-br from-[#7091E6]/10 to-transparent rounded-full filter blur-3xl" data-id="element-460"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gradient-to-tr from-[#3D52A0]/10 to-transparent rounded-full filter blur-3xl" data-id="element-461"></div>
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-462">
        <ScrollReveal data-id="element-463">
          <div className="flex flex-col items-center mb-16" data-id="element-464">
            <span className="inline-block px-4 py-1 bg-[#3D52A0]/10 rounded-full text-sm font-medium text-[#3D52A0] mb-6" data-id="element-465">
              The Impact
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-[#3D52A0] mb-6 text-center" data-id="element-466">
              Turn moments into movement.
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#3D52A0] to-[#7091E6] rounded-full mb-6" data-id="element-467"></div>
            <p className="text-lg md:text-xl text-gray-700 mb-12 text-center max-w-3xl mx-auto" data-id="element-468">
              With Shepherd Flow AI, every church can deliver world-class
              communication that connects people, builds relationships, and
              drives lasting impact.
            </p>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-4 gap-6 mb-16" data-id="element-469">
          <ScrollReveal delay={100} data-id="element-470">
            <div className="flip-card h-48" data-id="element-471">
              <div className="flip-card-inner" data-id="element-472">
                <div className="flip-card-front bg-white p-6 rounded-xl shadow-md text-center flex flex-col items-center justify-center" data-id="element-473">
                  <div className="bg-[#7091E6]/20 p-3 rounded-full w-14 h-14 mx-auto mb-4 flex items-center justify-center" data-id="element-474">
                    <Clock className="text-[#3D52A0] h-6 w-6" data-id="element-475" />
                  </div>
                  <h3 className="text-lg font-semibold text-[#3D52A0]" data-id="element-476">
                    Sign-Up Campaigns
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-477">
                    Personalized invitations
                  </p>
                </div>
                <div className="flip-card-back bg-[#3D52A0] p-6 rounded-xl shadow-md text-white flex flex-col items-center justify-center" data-id="element-478">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-479">
                    More event registrants
                  </h3>
                  <p className="text-sm" data-id="element-480">
                    Drive more sign-ups with targeted messaging that resonates
                    with your audience
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={200} data-id="element-481">
            <div className="flip-card h-48" data-id="element-482">
              <div className="flip-card-inner" data-id="element-483">
                <div className="flip-card-front bg-white p-6 rounded-xl shadow-md text-center flex flex-col items-center justify-center" data-id="element-484">
                  <div className="bg-[#7091E6]/20 p-3 rounded-full w-14 h-14 mx-auto mb-4 flex items-center justify-center" data-id="element-485">
                    <Users className="text-[#3D52A0] h-6 w-6" data-id="element-486" />
                  </div>
                  <h3 className="text-lg font-semibold text-[#3D52A0]" data-id="element-487">
                    Show-up Campaigns
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-488">Timely reminders</p>
                </div>
                <div className="flip-card-back bg-[#3D52A0] p-6 rounded-xl shadow-md text-white flex flex-col items-center justify-center" data-id="element-489">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-490">
                    Increased event attendance
                  </h3>
                  <p className="text-sm" data-id="element-491">
                    Ensure guests remember and attend your events with effective
                    reminders
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={300} data-id="element-492">
            <div className="flip-card h-48" data-id="element-493">
              <div className="flip-card-inner" data-id="element-494">
                <div className="flip-card-front bg-white p-6 rounded-xl shadow-md text-center flex flex-col items-center justify-center" data-id="element-495">
                  <div className="bg-[#7091E6]/20 p-3 rounded-full w-14 h-14 mx-auto mb-4 flex items-center justify-center" data-id="element-496">
                    <Zap className="text-[#3D52A0] h-6 w-6" data-id="element-497" />
                  </div>
                  <h3 className="text-lg font-semibold text-[#3D52A0]" data-id="element-498">
                    Follow-up Campaigns
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-499">
                    Personalized connections
                  </p>
                </div>
                <div className="flip-card-back bg-[#3D52A0] p-6 rounded-xl shadow-md text-white flex flex-col items-center justify-center" data-id="element-500">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-501">
                    More next steps
                  </h3>
                  <p className="text-sm" data-id="element-502">
                    Guide guests to their perfect next step with thoughtful
                    follow-up
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
          <ScrollReveal delay={400} data-id="element-503">
            <div className="flip-card h-48" data-id="element-504">
              <div className="flip-card-inner" data-id="element-505">
                <div className="flip-card-front bg-white p-6 rounded-xl shadow-md text-center flex flex-col items-center justify-center" data-id="element-506">
                  <div className="bg-[#7091E6]/20 p-3 rounded-full w-14 h-14 mx-auto mb-4 flex items-center justify-center" data-id="element-507">
                    <Heart className="text-[#3D52A0] h-6 w-6" data-id="element-508" />
                  </div>
                  <h3 className="text-lg font-semibold text-[#3D52A0]" data-id="element-509">
                    A Proven Communication Plan
                  </h3>
                  <p className="text-sm text-gray-500 mt-1" data-id="element-510">
                    Complete strategy
                  </p>
                </div>
                <div className="flip-card-back bg-[#3D52A0] p-6 rounded-xl shadow-md text-white flex flex-col items-center justify-center" data-id="element-511">
                  <h3 className="text-lg font-semibold mb-2" data-id="element-512">
                    Big Events & Lasting Impact
                  </h3>
                  <p className="text-sm" data-id="element-513">
                    Transform one-time events into ongoing relationships and
                    lasting community
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
        <ScrollReveal delay={300} data-id="element-514">
          <div className="bg-white rounded-xl shadow-xl overflow-hidden" data-id="element-515">
            <div className="grid md:grid-cols-2 items-stretch" data-id="element-516">
              {/* Testimonial Side */}
              <div className="bg-gradient-to-r from-[#3D52A0] to-[#7091E6] p-10 md:p-12 relative overflow-hidden" data-id="element-517">
                {/* Background wave pattern */}
                <div className="absolute inset-0 opacity-10" data-id="element-518">
                  <svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg" data-id="element-519">
                    <path d="M0,500 C200,300 800,700 1000,500 L1000,1000 L0,1000 Z" fill="white" data-id="element-520" />
                  </svg>
                </div>
                <div className="relative z-10 h-full flex flex-col justify-center" data-id="element-521">
                  <div className="absolute -top-8 -left-8 text-white text-8xl font-serif opacity-30" data-id="element-522">
                    "
                  </div>
                  <div className="absolute -bottom-8 -right-8 text-white text-8xl font-serif opacity-30" data-id="element-523">
                    "
                  </div>
                  <p className="text-xl md:text-2xl text-white font-light leading-relaxed mb-8" data-id="element-524">
                    "At Text In Church, I've worked with thousands of churches
                    that struggle to create effective communication plans.
                    Shepherd Flow AI was built to fix that—once and for all."
                  </p>
                  <div className="flex items-center gap-4" data-id="element-525">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mT6XSUgJnCSRSFnF9abBx3/Tyler_Smith_-_Headshot_03.jpg" alt="Tyler Smith" className="h-16 w-16 rounded-full object-cover border-2 border-white shadow-lg" data-id="element-526" />
                    <div className="text-white" data-id="element-527">
                      <p className="font-semibold text-lg" data-id="element-528">Tyler Smith</p>
                      <p className="text-white/80 text-sm" data-id="element-529">
                        Founder of Text In Church
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Info Side */}
              <div className="p-10 md:p-12 flex flex-col justify-center" data-id="element-530">
                <div className="bg-[#7091E6]/20 p-4 rounded-full w-fit mb-6 flex items-center justify-center" data-id="element-531">
                  <Award className="text-[#3D52A0] h-8 w-8" data-id="element-532" />
                </div>
                <h3 className="text-2xl font-bold text-[#3D52A0] mb-6" data-id="element-533">
                  Built by Church Leaders Who Get It
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-534">
                  Created by the team behind Text In Church and powered by
                  Gloo's large language model, Shepherd Flow AI was designed by
                  ministry-minded innovators who understand the unique
                  challenges of church communication.
                </p>
                <div className="flex flex-wrap gap-3 mt-auto" data-id="element-535">
                  <div className="bg-[#EDE8F5] px-3 py-1 rounded-full text-sm text-[#3D52A0] font-medium" data-id="element-536">
                    Ministry Experience
                  </div>
                  <div className="bg-[#EDE8F5] px-3 py-1 rounded-full text-sm text-[#3D52A0] font-medium" data-id="element-537">
                    Church-Focused AI
                  </div>
                  <div className="bg-[#EDE8F5] px-3 py-1 rounded-full text-sm text-[#3D52A0] font-medium" data-id="element-538">
                    Communication Experts
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
};
export default SuccessSection;